<template>
  <div class="wrapper">

    <w-navbar icon="iconchevron-left"
              nav_title="意向城市"
              right_btn_html="确认"
              :cvShow="true"
              @mobileLeftBtn="goBackFunc"
              @mobileRightBtn="confirmFunc"/>

    <div class="input-box">
      <input class="input" v-model="value" maxlength="50" placeholder="请填写意向城市" type="text" @input="searchFunc()">
      <div class="input-length-box">
        <span>{{ value.length }}</span>/50
      </div>
    </div>

    <div class="result-list" v-if="list && list.length">
      <div class="result-item" v-for="(item, index) in list" :key="`resultItem&${index}`" v-html="item.highlight" @click="selectFunc(item)"></div>
    </div>

  </div>
</template>

<script>
  import WNavbar from '@/components/global/w-navbar'
	import { mapState, mapMutations, mapActions } from 'vuex'

  export default {
    data () {
      return {
        value: '',
        city_id: '',
        list: []
      }
    },
    components: {
      WNavbar
    },
    computed: {
			...mapState('cv', [ 'cvIntentionData' ])
    },
    created () {
      console.log('$route', this.$route)
      this.value = this.cvIntentionData.exp_city || ''
      this.city_id = this.cvIntentionData.city_id
    },
    methods: {
      ...mapMutations('cv', [ 'setCvIntentionData' ]),

      // 返回
      goBackFunc () {
        this.$router.replace(`/cvs/${this.$route.params.token}/profiles`)
      },
      // 确认
      confirmFunc () {
        this.setCvIntentionData({
          ...this.cvIntentionData,
          exp_city: this.value,
          city_id:  this.city_id
        })
        this.goBackFunc()
      },
      // 选择
      selectFunc (data) {
        const { name, id } = data
        this.value = name
        this.city_id = id
        this.list = []
      },
      // 搜索
      async searchFunc () {
        try {
					let res = await this.$api.staticApi.cityComplete({
						keyword: this.value
					})
					if (res.code === 1000) {
						this.list = res.data
					}
				} catch (e) {
					console.log('意向城市自动补全 错误', e)
				}
      },
    }
  }
</script>

<style lang="scss" scoped>
  .wrapper {
    padding: 44px 24px 0;

    .input-box {
      display: flex;
      align-items: center;
      padding-bottom: 12px;
      margin-top: 32px;
      border-bottom: 1px solid #EEEFF0;

      .input {
        flex: 1;
        height: 22px;
        border: none;
        color: #404040;
        padding: 0;

        &::placeholder {
          color: #bcbcbc;
        }

      }

      .input-length-box {
        width: 60px;
        font-size: 16px;
        font-weight: 400;
        color: #CFCFCF;
        line-height: 22px;
        text-align: right;

        >span {
          color: #404040;
        }
      }
    }

    .result-list {
      height: 60vh;
      overflow-y: auto;
      // 隐藏滚动条
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE 10+ */
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }

      .result-item {
        font-size: 16px;
        font-weight: 400;
        color: #404040;
        line-height: 16px;
        padding: 18px 0;
        border-bottom: 1px solid #EEEFF0;

        ::v-deep .es-highlighter {
          color: #FF6644 ;
        }

      }
    }

  }

</style>
